// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-holder[data-v-09c69e31]{width:100%}@keyframes spin-09c69e31{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.loading[data-v-09c69e31]{animation:spin-09c69e31 1s linear infinite;border:.25rem solid rgba(0,0,0,.1);border-radius:50%;border-top-color:#fff;height:24px;margin:0 auto;width:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
